import React from "react";
import "./rarity.scss";
import { Container, Row, Col } from "react-bootstrap";
import { Parallax } from "react-parallax";

import badge from "../../../../assets/images/brandpush-trust-badge.png";

import dwarve8 from "../../../../assets/images/dwarve8.png";

const Rarity = () => {
  const handleRoute = () => {
    window.open(
      "https://www.marketwatch.com/press-release/angrydwarvestribenft-launches-nft-project-created-from-a-community-of-rug-pull-victims-2022-02-25",
      "_blank"
    );
  };
  return (
    <>
      <div className="rarity2_section">
        <Container>
          <div className="rarity_card">
            <Parallax>
              <h4 className="rarity_heading">Designs</h4>

              <Row>
                <p className="rarity_name">
                  The Angry Dwarves Tribe is a collection of 3,333hand-drawn
                  NFT's from Rhoser, a US-based artist..
                  <br />
                  <br />
                  1,111 Kingdom Coins
                </p>
              </Row>
            </Parallax>
          </div>

          <div className="rarity_card">
            <Parallax>
              <h4
                className="rarity_heading"
                style={{
                  color: "#56c7fc",
                }}
              >
                Clan Leaders
              </h4>

              <Row>
                <p className="rarity_name">
                  Each clan leader is a 1:1 rare NFT. They are suited in full
                  armour with specific unique colours: Obsidian, Diamond, Ruby,
                  Emerald & Topaz <br />
                  Anyone who mints a clan leader will receive $3000 in Ethereum
                  upon sell-out of the collection.
                  <br />
                  <br />
                </p>
              </Row>
            </Parallax>
          </div>

          <div className="rarity_card">
            <Parallax>
              <h4 className="rarity_heading">Rarity</h4>
              <Row>
                <Col xl={6}>
                  <div className="rarity_desc">
                    <h4 className="rarity_quantity">Clan Leaders</h4>
                  </div>
                </Col>
                <Col xl={6}>
                  <div className="rarity_desc">
                    <h4
                      className="rarity_quantity"
                      style={{ backgroundColor: "#56c7fc" }}
                    >
                      Warriors
                    </h4>
                    {/* <p className="rarity_name">Eyes</p> */}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xl={6}>
                  <div className="rarity_desc">
                    <h4 className="rarity_quantity">Hunters</h4>
                  </div>
                </Col>
                <Col xl={6}>
                  <div className="rarity_desc">
                    <h4
                      className="rarity_quantity"
                      style={{ backgroundColor: "#56c7fc" }}
                    >
                      Scavangers
                    </h4>
                    {/* <p className="rarity_name">Glasses</p> */}
                  </div>
                </Col>
              </Row>

              <div className="rarityimgdiv">
                <img src={dwarve8} alt="" />
              </div>
            </Parallax>
          </div>

          {/* <div
            className="badgediv"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img className="badgeimg" src={badge} onClick={handleRoute}></img>
          </div> */}
        </Container>
      </div>
    </>
  );
};

export default Rarity;
